
const earliestDeliveryInfoSelector = state => state && state.earliestDeliveryInfo;
export default earliestDeliveryInfoSelector;
